define('longpress-button',[],function() {
	var TIMEOUT = 300;
	var INTERVAL = 50;
	
	function makeLongpressButton(button) {
		var initialTimeout = 0;
		var interval = 0;
		var isCancelled = false;
		var isMousePressed = false;
		
		button.on('mousedown', function(e) {
			if (e.which != 1) // only left button
				return;
			down();
			isMousePressed = true;
			$(window).on('mouseup', onWindowMouseup);
		});
		
		button.on('mouseenter', function() {
			if (isMousePressed) {
				isCancelled = false;
				beginInterval(); // skip initial timeout
			}
		});
		
		button.on('mouseleave', function() {
			up();
		});
		
		function onWindowMouseup(e) {
			if (e.which != 1) // only left button
				return;
			
			up();
			isMousePressed = false;
			$(window).off('mouseup', onWindowMouseup);
		}
		
		button.on('keydown', function(e) {
			if (e.which == 32) // space as an alternative to button
				down();

			if (e.which == 13) // enter key
				notifyTick();
		});
		
		button.on('keyup', function(e) {
			if (e.which == 32) // space as an alternative to button
				up();
		});
		
		function down() {
			isCancelled = false;
			notifyTick();
			if (!interval && !initialTimeout)
				this.initialTimeout = setTimeout(beginInterval, TIMEOUT);
		}
		
		function up() {
			isCancelled = true;
			if (interval)
				clearInterval(interval);
			interval = 0;
			if (initialTimeout)
				clearTimeout(initialTimeout);
			initialTimeout = 0;
			button.trigger('up');
		}
		
		function beginInterval() {
			initialTimeout = 0;
			if (!interval && !isCancelled)
				interval = setInterval(intervalTick, INTERVAL);
		}
		
		function intervalTick() {
			if (!isCancelled)
				notifyTick();
		}
		
		function notifyTick() {
			button.triggerHandler('tick');
		}
		
		button.manualUp = up;
		button.manualDown = down;
	}
	
	return {
		make: makeLongpressButton
	};
});

